'use client';
import { ImgComparisonSlider } from '@img-comparison-slider/react';
import Image from 'next/image';

const CaseSlider = ({ first, second }: { first: string; second: string }) => {
  return (
    <ImgComparisonSlider
      className="coloured-slider"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <Image
        width={1120}
        height={1449}
        slot="first"
        src={first}
        alt="before"
        className="opacity-80 dark:invert-[90] dark:hue-rotate-180"
        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
      />
      <Image
        width={1120}
        height={1449}
        slot="second"
        src={second}
        alt="after"
        className="opacity-90 dark:opacity-100 dark:invert-[90] dark:hue-rotate-180"
        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
      />
    </ImgComparisonSlider>
  );
};

export default CaseSlider;
